import {
  FormControl,
  InputLabel,
  FormHelperText,
  AutocompleteProps,
  Autocomplete,
  TextField,
  styled,
  AutocompleteChangeReason
} from '@mui/material';
import { t } from 'i18next';
import { ReactNode, SyntheticEvent, useState } from 'react';
import { ControllerRenderProps, FieldValues, useController, useFormContext } from 'react-hook-form';
import { OptionField } from 'types/form.type';

interface Props extends Omit<AutocompleteProps<OptionField, false, false, false>, 'label'> {
  name?: string;
  label: string | ReactNode;
  hookForm?: ControllerRenderProps<FieldValues, string>;
}

const AutocompleteInput = ({ label, hookForm, ...props }: Props) => {
  const { fieldState } = useController({ name: hookForm?.name ?? '' });
  const { setValue } = useFormContext();
  const [inputChange, setInputChange] = useState('');

  const onFieldChange = (
    _event: SyntheticEvent<Element, Event>,
    value: OptionField | null,
    reason: AutocompleteChangeReason
  ) => {
    if (reason === 'clear') {
      return hookForm?.onChange('');
    }

    if (reason === 'selectOption') {
      if (hookForm?.name === 'entity.address.city') {
        setValue('entity.address.dati2', value?.key);
      }

      if (hookForm?.name === 'entity.izin_usaha.type') {
        hookForm?.onChange(' ');
      }

      setTimeout(() => {
        hookForm?.onChange(value?.value);
      }, 0);
    }
  };

  return (
    <FormControl sx={{ pt: 2, mb: 2 }} fullWidth={props.fullWidth} error={Boolean(fieldState.error?.message)}>
      <InputLabel shrink htmlFor={props.name}>
        {label}
      </InputLabel>
      <AutocompleteStyled
        clearOnEscape
        fullWidth={props.fullWidth}
        options={props.options || []}
        getOptionLabel={(option) => t(option.label)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} />}
        defaultValue={props.options.find((option) => option.value === hookForm?.value)}
        inputValue={inputChange}
        onInputChange={(_, value) => setInputChange(value)}
        onChange={onFieldChange}
        sx={{ minWidth: props.fullWidth ? 'unset' : 308, mt: 1 }}
      />
      <FormHelperText sx={{ m: 0 }}>{fieldState.error?.message}</FormHelperText>
    </FormControl>
  );
};

const AutocompleteStyled = styled(Autocomplete)(() => ({
  '& .MuiTextField-root': {
    backgroundColor: 'white'
  },
  '& .MuiInputBase-root ': {
    padding: '4px 32px 4px 12px'
  },
  '& input.MuiInputBase-input': {
    border: 'none',
    '&.MuiInputBase-input:focus': {
      boxShadow: 'unset'
    }
  }
})) as typeof Autocomplete;

export default AutocompleteInput;
